<div class="d-flex align-items-center">
    <div class="case">
        <div class="case-action">
            <mat-select id="status" [(ngModel)]="selectedStatus" (ngModelChange)="onChange($event)"
                panelClass="caseStatusOption">
                <mat-select-trigger class="case-action_status" [ngClass]="selectedStatus?.status?.toLowerCase()">
                    <span class="case-action_span">{{selectedStatus?.status}}<i class="fa fa-chevron-down"></i></span>
                </mat-select-trigger>
                <mat-option [value]="status" *ngFor="let status of claimStatus">
                    <div class="case-action_status" [ngClass]="status.status?.toLowerCase()">
                        <span>{{ status?.status }}</span>
                    </div>
                </mat-option>
            </mat-select>
            <ng-container >
              <span *ngIf="params.data.CaseStatusId == 4" class="case-action_currency" [matTooltip]="params.data.RefundedAmount">{{params.data.RefundedAmount | currency}}</span>
              <i *ngIf="params.data.CaseStatusId == 4 && params.data.RefundedAmount" class="fal fa-edit text-primary hand" [matTooltip]="'Edit'" (click)="openRefundAmount(params.data.RefundedAmount)"></i>
              <i *ngIf="params.data.CaseStatusId == 4 && !params.data.RefundedAmount" class="fal fa-plus-circle text-primary hand" [matTooltip]="'Add'" (click)="openRefundAmount()"></i>
              <i *ngIf="params.data.CaseStatusId == 4" [matTooltip]="'Refunded'" class="fas fa-check-circle text-success" ></i>
            </ng-container>
            <app-button *ngIf="!params?.data?.CaseCreationDate" [buttonSize]="'action'" (click)="openCaseDialog($event,params)">Open Case</app-button>
        </div>
        <div class="case-actionLink">
            <a class="hand" *ngIf="!params?.data.CaseLink" (click)="openDialog(true)">+ Add Link</a>
            <a class="hand" *ngIf="params?.data.CaseLink"
                [matTooltip]="params.data.CaseLink" (click)="openLink(params.data.CaseLink)">{{params.data.CaseLink}}</a>
            <i *ngIf="params?.data.CaseLink" class="fal fa-trash-alt text-red hand ms-2"
                (click)="deleteLink($event)"></i>
        </div>
    </div>
    <div class="ms-3">
        <div class="item">
            <span class="item_title">Created Date : </span>
            <span class="item_value ng-star-inserted">{{params.data.CaseCreationDate | date: 'MM/dd/yy hh:mm a'}}</span>
        </div>
        <div class="item">
            <span class="item_title">Last Updated Date : </span>
            <span class="item_value ng-star-inserted">{{params.data.DateModified | date: 'MM/dd/yy hh:mm a'}}</span>
        </div>
    </div>
</div>